import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ApiBaseResponse } from '../../models';
import { EncrDecrService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class ProfileRepository {
  private apiBaseUrl = environment.apiUrl;

  constructor(private http: HttpClient, private encryptService: EncrDecrService) { }

  changePassword(currentPassword: string, newPassword: string) {
    currentPassword = this.encryptService.encryptObject(currentPassword);
    newPassword = this.encryptService.encryptObject(newPassword);
    return this.http
      .post<ApiBaseResponse<null>>(
        `${this.apiBaseUrl}/Profile/changePassword`,
        {
          currentPassword,
          newPassword,
        }
      )
      .pipe(map((it) => it.data));
  }
}
